{
    "square": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 0
    },
    "circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 0
    },
    "triangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 0
    },
    "slim_star": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 0
    },
    "slim_octagram": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 96,
        "y": 0
    },
    "diamond": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 24
    },
    "pentagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 24
    },
    "hexagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 24
    },
    "heptagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 24
    },
    "poles": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 96,
        "y": 24
    },
    "horizontal_rectangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 48
    },
    "vertical_rectangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 48
    },
    "star": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 48
    },
    "xl_octogram": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 48
    },
    "outline_square": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 72
    },
    "outline_circle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 72
    },

    "outline_triangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 72
    },
    "outline_slim_star": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 72
    },
    "outline_slim_octagram": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 96,
        "y": 72
    },
    "outline_diamond": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 96
    },
    "outline_pentagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 96
    },
    "outline_hexagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 96
    },
    "outline_heptagon": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 96
    },
    "outline_poles": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 96,
        "y": 96
    },
    "outline_horizontal_rectangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 120
    },
    "outline_vertical_rectangle": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 120
    },
    "outline_star": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 120
    },
    "outline_xl_octogram": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 120
    },
    "solo_vertical_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 144
    },
    "double_vertical_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 144
    },
    "solo_vertical_diagonal": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 144
    },
    "double_vertical_diagonal": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 144
    },
    "rectangle_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 0,
        "y": 168
    },
    "right_arrow_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 24,
        "y": 168
    },
    "left_arrow_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 48,
        "y": 168
    },
    "double_arrow_line": {
        "height": 24,
        "pixelRatio": 1,
        "sdf": true,
        "width": 24,
        "x": 72,
        "y": 168
    }
}
